<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
            <div class="content-bottom-padded">
                <el-alert type="info" title="操作说明" show-icon >
                    <div> 说明：由本站推送至药关爱的数据 </div>
                </el-alert>
            </div>
            <el-row :gutter="20">
              <el-select size="small" v-model="params.payStatus" clearable placeholder="请选择支付状态" @change="search">
                  <el-option v-for="item in payStatusOption" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
              </el-select>
              <el-select size="small" v-model="params.isPush" clearable placeholder="请选择推送状态" @change="search">
                  <el-option v-for="item in isPushOption" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
              </el-select>
              <el-col :md="10" :lg="8">
                  <el-date-picker v-model="start_at" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="截至时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
              </el-col>
              <el-button type="primary" @click="supreData" v-loading="supreDataloading">财务校验</el-button>
              <el-button type="primary" @click="exportData" v-loading="exportloading">导出数据</el-button>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-button-group>
                     </el-button-group>
                </el-col>
            </el-row>
            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="applyNo" label="订单号"></el-table-column>
                <el-table-column prop="source" label="来源(本站)"></el-table-column>
                <el-table-column prop="realName" label="用户昵称"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="payNo" label="支付单号"></el-table-column>
                <el-table-column prop="create_at" label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.create_at | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payWay" label="⽀付⽅式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payWay==1">余额扣款</span>
                        <span v-else-if="scope.row.payWay==2">微信</span>
                        <span v-else-if="scope.row.payWay==3">支付宝</span>
                        <span v-else="scope.row.payWay==4">其他</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="storeName" label="门店名称"></el-table-column>
                 <el-table-column prop="storeNo" label="门店编号"></el-table-column>
                 <el-table-column prop="amount" label="实付金额"></el-table-column>
                 <el-table-column prop="bizNo" label="药关爱订单号"></el-table-column>
                 <el-table-column prop="payStatus" label="支付状态">
                   <template slot-scope="scope">
                       <span v-if="scope.row.payStatus==0">未支付</span>
                       <span v-else-if="scope.row.payWay==1">已支付</span>
                       <span v-else-if="scope.row.payWay==2">退货/退款</span>
                   </template>
                 </el-table-column>
                 <el-table-column prop="isPush" label="推送状态">
                   <template slot-scope="scope">
                       <span v-if="scope.row.isPush==0">未推送</span>
                       <span v-else-if="scope.row.isPush==1">已推送</span>
                   </template>
                 </el-table-column>
            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>



        </div>
        <router-view></router-view>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex'


    import { getYgaList,getYgaListPost,supreDataAdd } from '../../../api/third'

    export default {
        data () {
            return {

                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,

                },
                payStatusOption: [
                    { name: '未支付', value: 0 },
                    { name: '已支付', value: 1 },
                    { name: '退款/退货', value: 2 },
                ],
                isPushOption: [
                    { name: '未推送', value: 0 },
                    { name: '已推送', value: 1 },
                ],
                list: [],
                total_count:0,
                start_at:'',
                exportloading:false,
                supreDataloading:false
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {

            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            clickSearch (e) {
                this.params.page = 1
                this.getList()
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            getList () {
                this.loading = true
                console.log(this.params)
                getYgaList(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count
                    }
                    this.loading = false
                })
            },
            exportData(){
              getYgaListPost(this.params).then(response => {
                  this.exportloading = true
                   if (res.data.status) {
                       this.$message({
                           type: 'success',
                           message: '已加入执行队列，请在设置-导出列表中下载'
                       })
                       return
                   }else {
                       this.$message({
                           type: 'error',
                           message: '无内容可导出 或 执行失败，请检查重试'
                       })
                       return
                   }
               }).catch( error => {
                   this.exportloading = false
               })
            },
            supreData(){
              supreDataAdd(this.params).then(response => {
                  this.supreDataloading = true
                   if (res.data.status) {
                       this.$message({
                           type: 'success',
                           message: '操作成功'
                       })
                       return
                   }else {
                       this.$message({
                           type: 'error',
                           message: '无内容可导出 或 执行失败，请检查重试'
                       })
                       return
                   }
               }).catch( error => {
                   this.supreDataloading = false
               })
            },
            dateChange (val) {
                if (val && val.length > 0) {
                    this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_at = ''
                    this.params.end_at = ''
                }
                this.search();
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            search(){
              this.getList()
            },
            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// export_yga.vue?bcd2240a